import { render, staticRenderFns } from "./warningrecord.vue?vue&type=template&id=3371b869&scoped=true&"
import script from "./warningrecord.vue?vue&type=script&lang=js&"
export * from "./warningrecord.vue?vue&type=script&lang=js&"
import style0 from "./warningrecord.vue?vue&type=style&index=0&id=3371b869&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3371b869",
  null
  
)

export default component.exports